import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { curationsApiPath } from './apiPath';

const GetCurationsOrderListResponseDataSchema = z.object({
  curations: z.array(
    z.object({
      id: z.string(),
      title: z.string(),
      ordNo: z.number(),
      type: z.string().nullish(),
      isPublished: z.boolean().optional(),
    }),
  ),
});

type GetCurationsOrderListResponseData = z.infer<typeof GetCurationsOrderListResponseDataSchema>;

type GetCurationsOrderListResponse = MusinsaStandardResponse<GetCurationsOrderListResponseData>;

interface GetCurationsOrderListRequest {
  type?: 'GOODS' | 'SNAP2';
}

export const getCurationsOrderList = (request?: GetCurationsOrderListRequest) =>
  executeStandardRequest(async () =>
    privateHttpClient.get<GetCurationsOrderListResponse>(curationsApiPath.getCurationsOrderList, {
      ...(request?.type ? { type: request.type } : {}),
    }),
  );
